import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import CircleExclamation from 'assets/icons/circle_exclamation.svg'
import ModalContainer from 'components/ModalContainer'
import SegmentDetails from 'components/SegmentDetails'
import bootstrap from 'constants/bootstrap'
import { buildTranslate } from 'locales'
import { Fields as TargetSegment } from 'models/TargetSegment'
import { useMediaQuery } from 'react-responsive'
import './SegmentDetailsModal.scss'

const t = buildTranslate('components.ai.segment_visualization')
const tError = buildTranslate('errors')

type Props = {
  isOpen: boolean
  segment: TargetSegment | undefined
  // The clean segment name from the chat card, so the title renders on the
  // first pass instead of waiting on the fetch. Falls back to the fetched
  // record's name (which carries a hash and draft suffix) when absent.
  title?: string
  loading: boolean
  error: boolean
  onClose: () => void
  onCreateCampaign: () => void
}

const SegmentDetailsModal = ({
  isOpen,
  segment,
  title,
  loading,
  error,
  onClose,
  onCreateCampaign,
}: Props) => {
  const isXs = useMediaQuery({ maxWidth: bootstrap.screenXsMax })

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? segment?.name ?? ''}
      width={isXs ? '100%' : '1000px'}
      position={isXs ? undefined : 'top'}
      className="segment-details-modal"
      dialogStyle={
        isXs
          ? {
              height: '100vh',
              maxHeight: 'none',
              marginTop: 0,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              boxShadow: 'none',
            }
          : {
              maxHeight: '75vh',
              marginTop: '10vh',
              maxWidth: '100%',
            }
      }
      proceedText={t('create_campaign')}
      onProceed={onCreateCampaign}
      canProceed={!!segment && !error}
    >
      <Switch
        condition={error}
        fallback={
          // The tabs render straight away and carry the spinner in their own
          // content region, so the modal frame doesn't reflow when the segment
          // lands.
          <SegmentDetails
            segment={segment}
            loading={loading}
            id="ai-segment-details"
            className="mt-m segment-details-modal__content"
          />
        }
      >
        <div
          data-testid="segment-details-modal-error"
          className="d-flex flex-column align-items-center justify-content-center mt-m"
        >
          <div>
            <img src={CircleExclamation} alt="" width="32" height="32" />
          </div>
          <Text.Header4 bold className="mt-m mb-xs grey-90">
            {tError('network_response_error')}
          </Text.Header4>
        </div>
      </Switch>
    </ModalContainer>
  )
}

export default SegmentDetailsModal
